import { useMemo } from "react";

import { CustomerDoc } from "@megaron/docs-contracts";
import { useClientManager } from "@megaron/react-clients";
import { TicketDetailDto } from "@megaron/support-contracts";
import { Uuid } from "@megaron/uuid";

export function useResolvedCrmCustomerId(ticket: TicketDetailDto): Uuid | undefined {
  const bulkQuery = useClientManager("crm")
    .customerDocBulkQuery()
    .useQuery(
      { customerUuids: ticket.crmCustomerUuid ? [ticket.crmCustomerUuid] : [] },
      { enabled: !!ticket.crmCustomerUuid },
    );

  const searchQuery = useClientManager("docs")
    .searchCustomers()
    .useQuery(
      { searchText: ticket.reporterEmail.trim(), limit: 10 },
      { enabled: !ticket.crmCustomerUuid && !!ticket.reporterEmail.trim() },
    );

  return useMemo(() => {
    if (ticket.crmCustomerUuid) return bulkQuery.data?.[0]?.uuid;
    const lower = ticket.reporterEmail.trim().toLowerCase();
    const matched = (searchQuery.data?.items ?? []).find(
      (c: CustomerDoc) => c.email?.trim().toLowerCase() === lower,
    );
    return matched?.uuid;
  }, [ticket.crmCustomerUuid, ticket.reporterEmail, bulkQuery.data, searchQuery.data]);
}
